const forms = Array.from(document.querySelectorAll('.js-add-to-basket'));

if (forms) {
	forms.forEach(form => {
		form.addEventListener('submit', onSubmit);
		form.addEventListener('change', onChange);
	});
}

function onSubmit(event) {
	updateCart(event.target)
		.then(response => response.json())
		.then(json => updateUi(json));

	event.preventDefault();
}

function updateCart(form) {
	const inputs = form.elements;
	const url = inputs['action'].value;
	const button = form.querySelector('.js-submit');

	const options = {
		method: 'post',
		body: new FormData(form),
		headers: {
			Accept: 'application/json',
			'X-Requested-With': 'XMLHttpRequest',
			'Cache-Control': 'no-store',
		},
	};

	button.innerText = 'Item Added';
	button.style.backgroundColor = '#636363';

	setTimeout(function() {
		button.innerText = 'Add to Basket';
		button.style.backgroundColor = '#d0cfc5';
	}, 2000);

	return fetch(url, options);
}

function updateUi(json) {
	const counts = Array.from(document.querySelectorAll('.js-basket-count'));

	counts.forEach(element => {
		element.classList.add('is-active');
		element.textContent = json.cart.lineItems.length;
	});
}

function onChange(event) {
	let input = event.target;
	let option = input.options[input.selectedIndex];
	let button = input.form.querySelector('.js-submit');

	if (option.getAttribute('data-stock') == 0 && option.getAttribute('data-unlimited-stock') == 0) {
		button.setAttribute('disabled', '');
		button.textContent = 'Unavailable';
	} else {
		button.removeAttribute('disabled');
		button.textContent = 'Add to basket';
	}
}
